<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <div class="mb-3">
            <router-link to="/codigos_influencers/1" class="btn btn-orange rounded-pill">
              <i class="bx bx-chevron-left"></i> Regresar
            </router-link>

            <br />
          </div>
          <div class="row">
            <div class="col-lg-12">
              <h3 class="text-orange">Usuarios</h3>
              <hr />
            </div>
            <!-- <div class="col-lg-12 text-end mb-3">
              <router-link to="/nueva_membresia" class="btn btn-orange btn-lg rounded-pill">
                <i class="bx bxs-plus-circle"></i> Nuevo usuario
              </router-link>
            </div> -->
          </div>
          <div class="row">
            <div class="col-lg-12"></div>
          </div>
        </div>
      </transition>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header"></div>
              <div class="card-body">
                <div class="mt-3 mb-3">
                  <label>Buscar</label>
                  <div class="input-group mb-3 shadow border">
                    <span class="input-group-text" id="basic-addon1"><strong><i class="bx bx-search-alt"></i></strong>
                    </span>
                    <input v-on:keyup="get_search" v-model="search" type="text" class="form-control"
                      placeholder="Buscar usuario..." aria-label="Username" aria-describedby="basic-addon1" />
                  </div>
                </div>
                <div v-if="loading_usuarios" class="text-center">
                  <div class="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
                <div v-else>
                  <div class="card card-body shadow border">
                    <h4 class="text-primary fw-bold">Código: {{ codigo }}</h4>
                    <h4 class="text-primary fw-bold">
                      Registros: {{ usuarios.length }}
                    </h4>
                    <div class="row">
                      <div class="form-group col-md-6 col-sm-12">
                        <label>Estado Usuario</label>
                        <!-- <label>Mes de registro</label> -->
                        <select v-model="estado" v-on:change="get_usuarios" class="form-control">
                          <option value="null">Todos</option>
                          <option value="0">Interesado</option>
                          <option value="1">Pendiente</option>
                          <option value="3">Exitosa</option>
                        </select>
                      </div>
                      <div class="form-group col-md-6 col-sm-12">
                        <label>Periodo de Facturación</label>
                        <!-- <label>Mes de registro</label> -->
                        <input v-on:change="get_usuarios" v-model="fecha" type="month" class="form-control" />
                      </div>
                      <div class="col-md-12">
                        <button class="btn btn-outline-primary btn-sm rounded-pill" v-on:click="getLiquidacion($event)">
                          Liquidar
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <transition appear name="slide-fade">
                    <div v-if="usuarios.length != 0">
                      <div>
                        <table class="table table-bordered table-condensed table-hover my_table_1">
                          <thead>
                            <tr>
                              <th style="width: 2%">#</th>
                              <th style="width: 20%">Nombres y apellidos</th>
                              <th class="text-center" style="width: 6%">
                                Estado
                              </th>
                              <th class="text-center" style="width: 10%">
                                Agente
                              </th>
                              <th style="width: 10%">Email</th>
                              <th style="width: 10%">WhatsApp</th>
                              <th style="width: 10%">Celular</th>
                              <th style="width: 12%">Dirección</th>
                              <th class="text-center" style="width: 12%">
                                Opciones
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(usuario, index_usuario) in usuarios" v-bind:key="index_usuario">
                              <td>{{ usuario.num }}</td>
                              <td class="text-uppercase fw-bold text-orange">
                                {{ usuario.nombres }} {{ usuario.apellidos }}
                              </td>
                              <td class="text-center">
                                <span>
                                  <span v-if="usuario.estado_registro == 0"
                                    class="badge bg-primary fw-bold">Interesado</span>
                                  <span v-if="usuario.estado_registro == 1"
                                    class="badge bg-danger fw-bold">Pendiente</span>
                                  <span v-if="usuario.estado_registro == 2"
                                    class="badge bg-success fw-bold">Completa</span>
                                  <span v-if="usuario.estado_registro == 3"
                                    class="badge bg-warning fw-bold">Exitosa</span>
                                </span>
                              </td>
                              <td>
                                <div v-if="usuario.agente != null">
                                  <span class="text-uppercase">{{
                                    usuario.agente.usuario
                                  }}</span>
                                </div>
                                <small class="text-muted">
                                  {{ usuario.fecha_registro }}
                                </small>
                              </td>
                              <td>
                                {{ usuario.email }}
                              </td>
                              <td>{{ usuario.whatsapp }}</td>
                              <td>{{ usuario.celular }}</td>
                              <td>{{ usuario.direccion }}</td>
                              <td class="text-center">
                                <div class="dropdown">
                                  <a class="btn btn-outline-primary btn-sm rounded-pill dropdown-toggle"
                                    href="javascript:void(0)" role="button" id="dropdownMenuLink"
                                    data-bs-toggle="dropdown" aria-expanded="false">
                                    Opciones
                                  </a>

                                  <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink">
                                    <li>
                                      <router-link class="dropdown-item" v-bind:to="
                                        '/usuario/info_basica/' +
                                        usuario.id_usuario
                                      ">
                                        Información básica
                                      </router-link>
                                    </li>
                                    <li>
                                      <router-link class="dropdown-item" v-bind:to="
                                        '/beneficiarios/' + usuario.id_usuario
                                      ">
                                        Beneficiarios
                                      </router-link>
                                    </li>
                                    <li>
                                      <router-link class="dropdown-item" v-bind:to="
                                        '/pago/' + usuario.id_usuario
                                      ">
                                        Pago
                                      </router-link>
                                    </li>
                                    <li>
                                      <router-link class="dropdown-item" v-bind:to="
                                        '/anexos_membresia/' +
                                        usuario.id_usuario
                                      ">
                                        Anexos
                                      </router-link>
                                    </li>

                                    <li v-if="session.usuario.perfil == 0">
                                      <a v-on:click="
                                        show_modal_eliminar(index_usuario)
                                      " href="javascript:void(0)" class="dropdown-item text-danger">Eliminar</a>
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div v-else>
                      <div class="text-muted">
                        <i class="bx bx-info-circle"></i> No se encontraron
                        usuarios.
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="mt-4 mb-4" aria-label="Page navigation example" v-html="paginate"></div>
          </div>
        </div>
      </transition>
    </div>
    <modal name="modal_eliminar" :adaptive="true" height="250">
      <div class="card m-4">
        <div class="card-header">
          <h4 class="fw-bold text-danger">Eliminar usuario</h4>
        </div>
        <div class="card-body">
          <div v-if="index_select != null" class="text-danger">
            ¿Desea eliminar al usuario
            <strong>{{ usuarios[index_select].nombres }}
              {{ usuarios[index_select].apellidos }}</strong>?
          </div>
          <hr />
          <div class="text-end">
            <button @click="eliminar" class="btn btn-danger rounded-pill">
              Sí
            </button>
            <button @click="$modal.hide('modal_eliminar')" class="btn btn-outline-secondary rounded-pill">
              No
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal name="modal_liquidacion" :adaptive="true" height="auto">
      <div class="card m-4" id="element-to-convert">
        <div class="card-header">
          <h2 class="fw-bold text-orange">Liquidacion Usuarios</h2>
        </div>
        <div class="card-body" v-if="codigo != null" style="height:70vh;overflow-y:scroll">
          <div class="row">
            <div class="col-md-12">
              <h2>Codigo:</h2>
              <h4>{{ codigo }}</h4>
              <br>
            </div>
            <div class="col-md-6">
              <h2>Fecha generación:</h2>
              <h4>{{ today.getFullYear() + '-' + today.getMonth() + '-' + today.getDate() }}</h4>
              <br>
            </div>
            <div class="col-md-6">
              <h2>Fecha liquidada:</h2>
              <h4>{{ fecha }}</h4>
              <br>
            </div>
          </div>
          <h2>Detalle liquidación</h2>
          <table class="table table-bordered table-condensed table-hover my_table_1">
            <thead>
              <tr>
                <th style="width: 2%">#</th>
                <th style="width: 20%">Nombre</th>
                <th class="text-center" style="width: 10%">
                  Tipo Membresia
                </th>
                <th style="width: 15%">
                  Comision Usuario
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(usuario, index_usuario) in usuarios" v-bind:key="index_usuario">
                <td>{{ usuario.num }}</td>
                <td>
                  <h5 class="text-orange fw-bold mb-0">
                    {{ usuario.nombres + ' ' + usuario.apellidos }}
                  </h5>
                </td>
                <td class="text-center">
                  {{ usuario.membresia.tipo_membresia == 1 ? 'Anual' : 'Semestral'
                  }}
                </td>
                <td>
                  <div v-if="usuario.membresia.tipo_membresia == 1">
                    {{ 30000 | currency }}
                  </div>
                  <div v-if="usuario.membresia.tipo_membresia == 2">
                    {{ 15000 | currency }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <br>
          <h2>Total a Pagar influencer :</h2>
          <h4>
            {{ total_liquidacion * 0.75 | currency }}
          </h4>
          <br>
          <h2>Total a Pagar agente :</h2>
          <h4>
            {{ total_liquidacion * 0.25 | currency }}
          </h4>
          <br>
          <h2>Total a Pagar:</h2>
          <h4>
            {{ total_liquidacion | currency }}
          </h4>
          <hr />
          <div class="text-end">
            <button class="btn btn-outline-secondary rounded-pill" @click="exportToPDF()">Export to PDF</button>
            <button @click="$modal.hide('modal_liquidacion')" class="btn btn-outline-secondary rounded-pill">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import "vue-select/dist/vue-select.css";
export default {
  name: "Usuarios_membresas",
  metaInfo: {
    title: "Usuarios membresías - Reddy Backoffice",
  },
  data() {
    return {
      today: new Date(),
      loading: true,
      loading_usuarios: true,
      id_codigo: null,
      codigo: null,
      search: null,
      usuarios: [],
      index_select: null,
      paginate: null,
      fecha: null,
      total_liquidacion: 0,
      estado: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_codigo = this.$route.params.id_codigo;
    this.get_usuarios();
  },
  methods: {
    get_usuarios: function () {
      this.loading_usuarios = true;
      var search = null;
      if (this.search != null && this.search.trim().length != 0) {
        search = this.search;
      }
      localStorage.setItem("page_usuarios", this.page);
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          id_codigo: this.id_codigo,
          search: search,
          fecha: this.fecha,
          estado: this.estado,
        },
      };
      axios
        .get(this.$base_url + "clientes/clientes_influencers", config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuarios = response.data.data.usuarios;
          this.get_paginate(response.data.data.total_pages);
          this.codigo = response.data.data.codigo;
          this.loading_usuarios = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_search: function () {
      if (this.page != 1) {
        this.page = 1;
        this.$router.push("/usuarios/1");
      }
      this.get_usuarios();
    },
    eliminar: function () {
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_usuario: this.usuarios[this.index_select].id_usuario,
      };
      axios
        .post(this.$base_url + "clientes/eliminar_usuario", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
          } else {
            vm.$notify({
              type: "success",
              group: "foo",
              title: "Eliminado!",
              text: response.data.message,
            });
          }
          vm.index_select = null;
          vm.$modal.hide("modal_eliminar");
          vm.get_usuarios();
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
    getLiquidacion: function () {
      this.total_liquidacion = 0;
      if (this.fecha == null || this.estado != 3) {
        this.$notify({
          type: "error",
          group: "foo",
          title: "Ups!",
          text: "Solo se pueden liquidar los Usuarios Exitosos con periodo seleccionado",
        });
      } else {
        let usuarios = [];
        this.usuarios.forEach(usuario => {
          let newUsuario = usuario;
          if (newUsuario.membresia.tipo_membresia == 1) {
            newUsuario.liquidacion_usuario = 30000;
          } else if (newUsuario.membresia.tipo_membresia == 2) {
            newUsuario.liquidacion_usuario = 15000;
          }

          newUsuario.liquidacion_total_usuario = newUsuario.liquidacion_usuario;
          this.total_liquidacion += newUsuario.liquidacion_total_usuario;
          usuarios.push(newUsuario);
        });
        this.usuarios = usuarios;
        console.log(this.usuarios)
        console.log(this.total_liquidacion)
        this.$modal.show("modal_liquidacion");
      }
    },
    get_paginate: function (tpages) {
      var page = this.page;

      if (page === undefined || page <= 0) {
        this.page = 1;
        page = this.page;
      }

      var adjacents = 4;

      var paginate = null;

      paginate = '<ul class="pagination justify-content-center text-center">';
      // previous label
      if (page == 1) {
        paginate +=
          "<li class='paginate_button page-item previous disabled'><a class='page-link disabled'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else if (page == 2) {
        paginate +=
          "<li class='paginate_button page-item  previous'><a href='#/usuarios/1' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      } else {
        var page_ant = parseFloat(page) - 1;
        paginate +=
          "<li class='paginate_button page-item'><a href='#/usuarios/" +
          page_ant +
          "' class='page-link' href='javascript:void(0);'>  <span aria-hidden='true'>&laquo;</span> </a></li>";
      }
      // first label
      if (page > parseFloat(adjacents) + 1) {
        paginate +=
          "<li class='paginate_button page-item'><a class='page-link' href='#/usuarios/1'>1</a></li>";
      }
      // interval
      if (page > parseFloat(adjacents) + 2) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // pages
      var pmin =
        page > adjacents ? parseFloat(page) - parseFloat(adjacents) : 1;
      var pmax =
        page < parseFloat(tpages) - parseFloat(adjacents)
          ? parseFloat(page) + parseFloat(adjacents)
          : tpages;

      for (var i = pmin; i <= pmax; i++) {
        if (i == page) {
          paginate +=
            "<li class='paginate_button page-item active'><a href='#/usuarios/" +
            i +
            "' class='page-link'>" +
            i +
            "</a></li>";
        } else if (i == 1) {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/usuarios/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        } else {
          paginate +=
            "<li class='paginate_button page-item'><a href='#/usuarios/" +
            i +
            "' class='page-link' href='javascript:void(0);'>" +
            i +
            "</a></li>";
        }
      }
      // interval
      if (page < parseFloat(tpages) - parseFloat(adjacents) - 1) {
        paginate += "<li class='paginate_button page-item'> <a> ... </a> </li>";
      }
      // last
      if (page < parseFloat(tpages) - parseFloat(adjacents)) {
        paginate +=
          "<li class='paginate_button page-item'><a  href='#/usuarios/" +
          tpages +
          "' class='page-link' href='javascript:void(0);'>" +
          tpages +
          "</a></li>";
      }
      // next
      if (page < tpages) {
        var page_next = parseFloat(page) + 1;
        paginate +=
          "<li class='paginate_button page-item next'><a  href='#/usuarios/" +
          page_next +
          "' class='page-link' href='javascript:void(0);'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      } else {
        paginate +=
          "<li class='paginate_button page-item next disabled'><a class='page-link disabled'> <span aria-hidden='true'>&raquo;</span> </a></li>";
      }
      paginate += "</ul>";
      this.paginate = paginate;
    },
  },
  mounted: function () {
    this.loading = false;
  },
  watch: {
    $route() {
      this.page = this.$route.params.page;
      this.get_usuarios();
    },
  },
};
</script>